const ROLES = Object.freeze({
    DEVELOPER: "9128",
    ADMIN: "9812",
    MANAJER: "9544",
    STAFF: "9344",
    DOSEN: "8465",
    MAHASISWA: "4564",    
})

export default ROLES;